//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('language', {
//        templateUrl: 'views/components/views/language/language.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'languageEditService', function ($stateParams, stateService, translateService, modalService, languageEditService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let languageId = $stateParams.language_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                languageNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('languagelangs', { language_id: vm.model.edit.language_id }) }
//                ],
//                edit: {},
//                selectListDateFormats: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await languageEditService.getEdit({ language_id: languageId }))[0];
//            }

//            async function loadDateFormats() {
//                vm.model.selectListDateFormats = await languageEditService.listDateFormats();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                languageEditService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//            	loadEdit();
//                loadDateFormats();
//            }

//            // #endregion ON INIT FUNCTION
//        }]
//    });
//})();
